import { IoIosMail } from 'react-icons/io'

export default {
  title: 'Klaviyo',
  name: 'klaviyo',
  type: 'document',
  icon: IoIosMail,
  __experimental_actions: ['update', 'publish'],
  fields: [
    {
      title: 'Signup List ID',
      name: 'listId',
      type: 'string'
    }
  ]
}
